/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable */
import './guideBookingTab.css';
import 'react-dates/lib/css/_datepicker.css';

import { useContext, useEffect, useMemo, useRef, useState } from 'react';

import { BookingDataContext } from '../../../context/BookingDataContext.jsx';
import { ReactComponent as Chevron } from '../../../assets/icons/trvto_downArrow.svg';
import { ReactComponent as Phone } from '../../../assets/icons/trvto_phone.svg';
import { ReactComponent as Message } from '../../../assets/icons/trvto_message.svg';
import { Navigate, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import moment from 'moment';
import tripBookingClick, {
    handleCustomTripBooking,
    handleGuUpdateNow,
    handleUpdateNow
} from './guideBookingTabFun/guideBookingClick.js';
import { toast } from 'react-toastify';
import {
    calculateDisplayedPrice,
    calculateOfferPrice,
    getHikedPrice,
    getTaxAmount
} from '../../../utils/getAmountWithTransaction.js';
import { comfortableOptions, vehicleModes } from './guideBookingTabFun/constants/GuideBookingConstant.js';
import { updateUserBookingDateAndPickupLocation } from '../../../api/userAPI.js';
import { GuideDataBookingTab } from './guideBookingTabFun/bookingTab/GuideDataBookingTab.jsx';
import guideBookingClick from './guideBookingTabFun/guideBookingClick.js';
import fetchTripData, { fetchTripDate } from '../guideDetailsFun/fetchTripData.js';

// reviewPath: v2 passes its own review page
export default function GuideBookingTab({ packData, packDates, setLoading, isExpanded, setIsExpanded, reviewPath }) {
    const { bookingData, setBookingData } = useContext(BookingDataContext);
    const [searchParams] = useSearchParams();
    const guestsParam = searchParams.get('guests');
    const [index, setIndex] = useState(0);
    const bookingTabRef = useRef(null);
    const naviagte = useNavigate();
    const numPeople = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const [timeSlots, setTimeSlots] = useState([]);
    const meetUpPoints = ['Hampi'];
    const [isReserveChecked, setIsReserveChecked] = useState(false);
    // const [isInstallmentChecked, setIsInstallmentChecked] = useState(false);
    const [booking, setBooking] = useState({
        packDateId: '',
        people: bookingData.people || 1,
        date: bookingData.date || null,
        timeSlots: bookingData.time || '',
        language: bookingData.language || '',
        meetupLocation: bookingData.meetupLocation || '',
        isReserved: false,
        amountPaid: {
            actual: 0,
            tax: 0,
            total: 0,
            isReserved: false,
            isInstallment: false,
            reserve: packData.price[0]?.reserve
        }
    });
    const [reviewPage, setReviewPage] = useState(false);
    const [offerData, setOfferData] = useState({});
    const [focused, setFocused] = useState(false);
    const formatDate = (date) => {
        return new Date(date).toISOString().split('T')[0];
    };

    useEffect(() => {
        const interval = setInterval(() => {
            const input = document.querySelector('input.DateInput_input');
            if (input && !input.readOnly) {
                input.setAttribute('readonly', true);
                clearInterval(interval);
            }
        }, 50);
        return () => clearInterval(interval);
    }, [focused]);

    useEffect(() => {
        if (!booking?.date) return;

        const getTripDate = async () => {
            const dateOnly = moment(booking.date).format('YYYY-MM-DD');

            const tripDate = await fetchTripDate({ date: dateOnly, contentId: packData._id });
            const availableSlots = tripDate?.slots.filter(
                (slot) => slot.availableSlots > 0 && slot.totalSlots - slot.bookedSlots > 0
            );
            setBooking((prev) => ({
                ...prev,
                guDatesId: tripDate?._id || ''
            }));

            setTimeSlots(availableSlots || []);
        };

        getTripDate();
    }, [booking.date]);

    const getTotalPrice = (actual, people, count, perPersonPrice) => {
        if (!people) return 0;

        if (people <= count) {
            return actual;
        }

        const extraPeople = people - count;

        return actual + extraPeople * perPersonPrice;
    };

    // const priceDetails = useMemo(() => {
    //     const basePrice = getHikedPrice(packData.price[0].actual);
    //     const subtotal = getTotalPrice(basePrice, booking.people, 952);
    //     const discount = Math.round(subtotal * 0.2);
    //     const actual = subtotal - discount;
    //     const tax = Math.round(actual * 0.05);
    //     const total = actual + tax;

    //     return { basePrice, subtotal, discount, tax, total, actual };
    // }, [booking.people, booking.amountPaid.actual]);

    const priceDetails = useMemo(() => {
        const selectedPrice = packData?.price?.find(
            (price) => String(price.placeId) === String(booking?.selectedPlaceId)
        );
        const people = Number(booking?.people || 1);

        if (!selectedPrice || people <= 0) {
            return {
                subTotal: 0,
                actual: 0,
                tax: 0,
                total: 0,
                pricePerPerson: 0,
                discount: 0,
                reserve: 0
            };
        }

        const actual = getTotalPrice(
            Number(selectedPrice.actual || 0),
            people,
            Number(selectedPrice.count || 1),
            Number(selectedPrice.perPersonPrice || 0)
        );
        const subTotal = getHikedPrice(actual);
        const pricePerPerson = Math.floor(actual / people);

        const discount = Math.floor(subTotal * 0.2);
        const tax = Math.floor(actual * 0.05); // 5%
        const total = actual + tax;
        const reserve = selectedPrice.reserve;
        const reserveTotal = reserve * people;
        return {
            subTotal,
            actual,
            tax,
            total,
            pricePerPerson,
            discount,
            reserve,
            reserveTotal
        };
    }, [booking?.selectedPlaceId, booking?.people, packData?.price]);

    const confirmedBookingData = useMemo(() => {
        const data = sessionStorage.getItem('confirmedBookingData');
        return data ? JSON.parse(data) : null;
    }, []);

    useEffect(() => {
        if (!confirmedBookingData) return;

        setBooking((prev) => ({
            ...prev,

            guDatesId: confirmedBookingData.guDatesId || prev.actDatesId,

            date: confirmedBookingData.startDate || prev.date,

            timeSlots: confirmedBookingData.timeSlots || confirmedBookingData.time || prev.timeSlots,

            totalSeats: confirmedBookingData.totalSeats || prev.totalSeats,

            meetupLocation: confirmedBookingData.meetupLocation || prev.meetupLocation,
            place: confirmedBookingData?.place || null,
            language: confirmedBookingData.language,
            amountPaid: {
                ...prev.amountPaid,
                ...(confirmedBookingData.amountPaid || {})
            }
        }));
    }, [confirmedBookingData]);

    useEffect(() => {
        if (Object.keys(bookingData).length !== 0) {
            setIsReserveChecked(bookingData?.amountPaid?.isReserved);
            setBooking({
                ...bookingData
            });
        }
    }, [bookingData]);

    const toggleExpand = () => {
        setIsExpanded((prev) => {
            const next = !prev;

            if (!prev) {
                setTimeout(() => {
                    bookingTabRef.current?.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }, 150);
            }

            return next;
        });
    };

    const handleCheckboxChange = (event) => {
        const checked = event.target.checked;
        setIsReserveChecked(checked);
        handleReservePay(checked);
    };

    const handleReservePay = (checked) => {
        setBooking((prev) => ({
            ...prev,
            amountPaid: {
                ...prev.amountPaid,
                isReserved: checked
            }
        }));
    };

    // useEffect(() => {
    //     localStorage.setItem('reserve', reserve);
    // }, [reserve]);

    const lowestPrice = packData?.price?.reduce((lowest, current) => {
        if (!lowest || current.perPersonPrice < lowest.perPersonPrice) {
            return current;
        }
        return lowest;
    }, null);
    const showPrice = lowestPrice.perPersonPrice || 0;

    if (reviewPage) {
        return <Navigate to={reviewPath || '/gu/review-booking'} />;
    }

    return (
        <div ref={bookingTabRef} className={`tripBookingTab guBookingWrapper ${isExpanded ? 'expanded' : 'collapsed'}`}>
            <div className={`tripBookingPriceDiv ${isExpanded ? 'expanded' : 'collapsed'}`}>
                <div className='toggleOverlay' onClick={toggleExpand} />
                <div>
                    <p className='tripBookingActualPrice'>Rs.{Math.round(getHikedPrice(showPrice || 0))}</p>
                    <p className='tripBookingOffer'>{20}% OFF</p>
                    <p className='tripBookingPrice'>
                        <span className='tripBookingPrice-span'>Starts from</span> Rs. {Math.round(showPrice || 0)}
                        <span className='tripBookingPrice-span'>/person</span>
                    </p>
                    <p className='tripBookingTaxInc'>Excluding all taxes</p>
                </div>
                <div className='tripBookingChevronWrapper'>
                    <button onClick={toggleExpand} className='collapseArrow'>
                        <Chevron width={24} height={24} />
                    </button>
                    {/* {isExpanded === true && (
                        <> */}
                    {confirmedBookingData ? (
                        <button
                            className='tripButton tripBookingSmallButton'
                            onClick={() =>
                                handleGuUpdateNow({
                                    booking,
                                    confirmedBookingData,
                                    updateUserBookingDateAndPickupLocation,
                                    naviagte
                                })
                            }
                        >
                            Update Now
                        </button>
                    ) : (
                        <button
                            className='tripButton tripBookingSmallButton'
                            onClick={() =>
                                tripBookingClick(
                                    booking,
                                    setBookingData,
                                    setReviewPage,
                                    packData,
                                    amount,
                                    setLoading,
                                    packDates
                                )
                            }
                        >
                            Select Date
                        </button>
                        //     )}
                        // </>
                    )}
                </div>
            </div>
            <div className='tripBookingSubTab'>
                <div className='tripBookDataInput'>
                    {/* <div className='guideNote'>
                        <p>
                            <span className='noteSpan'>Note:</span> The price is{' '}
                            <span style={{ fontWeight: '600' }}>₹2,999</span> for up to 3 persons. An additional charge
                            applies for each extra person.
                        </p>
                    </div> */}
                    {/* {!confirmedBookingData && packData?.price[0]?.reserve !== 0 && (
                        <div className='reserve-card'>
                            <input
                                type='checkbox'
                                id='reserve'
                                checked={isReserveChecked}
                                onChange={handleCheckboxChange}
                            />
                            <label htmlFor='reserve' className='reserve-content'>
                                <div className='reserve-row'>
                                    <span className='reserve-title'>
                                        Reserve at Rs.{' '}
                                        {packData?.price[0]?.reserve
                                            ? `${Math.round(packData?.price[0]?.reserve)}`
                                            : ''}
                                        / person
                                    </span>
                                </div>
                                <div className='reserve-subtitle'>Pay the remaining amount on the trip</div>
                            </label>
                        </div>
                    )} */}
                    <GuideDataBookingTab
                        booking={booking}
                        setBooking={setBooking}
                        confirmedBookingData={confirmedBookingData}
                        numPeople={numPeople}
                        time={timeSlots}
                        languages={packData.quickView.languages}
                        meetupLocation={packData.meetupLocation}
                        price={packData.price}
                        packData={packData}
                    />

                    {/* <label className='tripBookDatalabel2'>Offer Code</label>
            <div className='tripBookOfferDiv'>
                <input
                    type='text'
                    placeholder='Enter promo code'
                    name='offerCode'
                    value={offerCode}
                    className='tripBookOfferIn'
                    onChange={(e) => handlePromoCode(e)}
                />
                <button
                    className='tripBookOfferBtn'
                    onClick={() => offerApplyTrip(offerCode, setOfferData, setBooking, booking, amount)}
                >
                    Apply
                </button>
            </div>  */}
                </div>
                {booking.place &&
                    !confirmedBookingData &&
                    (booking.amountPaid?.isReserved ? (
                        <>
                            <div className='tripPriceCal'>
                                <p className='tripBookPrice'>
                                    ₹{priceDetails?.reserve}x {booking?.people}
                                </p>
                                <p className='tripBookPrice'>₹{priceDetails?.reserveTotal}</p>
                            </div>

                            <div className='tripBookTotalDiv'>
                                <p className='tripBookTotalText'>Total:</p>
                                <p className='tripBookTotalText'>₹{priceDetails?.reserveTotal}</p>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className='tripPriceCal'>
                                <p className='tripBookPrice'>
                                    {booking?.people} x ₹{getHikedPrice(priceDetails?.pricePerPerson)}
                                </p>
                                <p className='tripBookPrice'>₹{priceDetails?.subTotal}</p>
                            </div>
                            <div className='tripBookOfferDiv'>
                                <p className='tripBookOfferText'>Discount</p>
                                <p className='tripBookOfferText'>- ₹{priceDetails?.discount}</p>
                            </div>
                            {Object.keys(offerData).length !== 0 && (
                                <div className='tripBookOfferDiv'>
                                    <p className='tripBookOfferText'>Offer</p>
                                    <p className='tripBookOfferText'>- ₹{booking?.amountPaid?.offerAmo}</p>
                                </div>
                            )}
                            <div className='tripBookTotalDiv'>
                                <p className='tripBookTotalText'>Total:</p>
                                <p className='tripBookTotalText'>₹{priceDetails.actual}</p>
                            </div>
                        </>
                    ))}
                <div className='tripBookBtnDiv'>
                    {confirmedBookingData ? (
                        <button
                            className='tripButton tripBookingButton'
                            onClick={() =>
                                handleGuUpdateNow({
                                    booking,
                                    confirmedBookingData,
                                    updateUserBookingDateAndPickupLocation,
                                    naviagte
                                })
                            }
                        >
                            Update Now
                        </button>
                    ) : (
                        <button
                            className='tripButton tripBookingButton'
                            onClick={() =>
                                guideBookingClick(
                                    booking,
                                    setBookingData,
                                    setReviewPage,
                                    packData,
                                    setLoading,
                                    priceDetails
                                )
                            }
                        >
                            Book Now
                        </button>
                    )}
                </div>
                <div className='helpSection'>
                    <div>Need Help?</div>
                    <div className='helpContact'>
                        <a href='tel:+918088788874' className='callBtn'>
                            <Phone width={20} height={20} />
                            Call
                        </a>
                        <a
                            className='chatBtn'
                            href={`https://wa.me/918088788874`}
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            <Message width={22} height={22} fill='black' />
                            Chat
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
